import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { bankOptions, daysOfWeekOptions, getDayOfWeekById } from '../../utils/Enums';

export const SUPPLIER_DETAILS_FIELDS = [
  'name',
  'business_name',
  'rut',
  'pickup_address',
  'business_phone',
  'email',
  'seller_name',
  'seller_phone'
];

const SupplierFormSteps = ({ activeStep, formData, errors, onChange, onDeliveryDaysChange, onMakesDeliveriesChange }) => {
  const { t } = useTranslation();

  if (activeStep === 0) {
    return (
      <Grid container spacing={2}>
        {SUPPLIER_DETAILS_FIELDS.map((field) => (
          <Grid item xs={12} sm={6} key={field}>
            <TextField
              required
              fullWidth
              label={t(field)}
              name={field}
              value={formData[field]}
              onChange={onChange}
              error={Boolean(errors[field])}
              helperText={errors[field]}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (activeStep === 1) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>{t('bank')}</InputLabel>
            <Select name="bank" value={formData.bank} onChange={onChange} label={t('bank')}>
              {bankOptions.map((bank) => (
                <MenuItem key={bank.id} value={bank.id}>{bank.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label={t('bank_account')} name="bank_account" value={formData.bank_account} onChange={onChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth type="number" label={t('credit_days')} name="credit_days" value={formData.credit_days} onChange={onChange} inputProps={{ min: 0 }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth type="number" label={t('anticipation_days')} name="anticipation_days" value={formData.anticipation_days} onChange={onChange} inputProps={{ min: 0 }} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Checkbox checked={formData.makes_deliveries} onChange={onMakesDeliveriesChange} />}
          label={t('makes_deliveries')}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth disabled={!formData.makes_deliveries} error={Boolean(errors.delivery_days)} required={formData.makes_deliveries}>
          <InputLabel>{t('delivery_days')}</InputLabel>
          <Select
            multiple
            name="delivery_days"
            value={formData.delivery_days}
            onChange={onDeliveryDaysChange}
            label={t('delivery_days')}
            renderValue={(selected) => selected
              .map((day) => getDayOfWeekById(day)?.label)
              .filter(Boolean)
              .map((label) => t(label))
              .join(', ')}
          >
            {daysOfWeekOptions.map((day) => (
              <MenuItem key={day.id} value={day.id}>{t(day.label)}</MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.delivery_days}</FormHelperText>
        </FormControl>
      </Grid>
      {!formData.makes_deliveries && (
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            {t('delivery_details_optional')}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SupplierFormSteps;
